import { useState } from "react";
import indiaStates from "../data/indiaStates.json";

// Real state-level boundary data (src/assets/in.svg -- Simplemaps.com, free for
// commercial use per the license notice in that file), not a hand-traced
// approximation. Illustrative sample presence -- shows the shape of the feature
// (a multi-site brand's footprint visible at a glance) rather than a specific
// named customer.
const ACTIVE_STATES = {
  INTN: [{ city: "Chennai", label: "Jewellery showroom" }],
};

const { viewBox: VIEWBOX, states } = indiaStates;

export function IndiaBranchMap() {
  const [active, setActive] = useState(null);
  const activeEntry = active && ACTIVE_STATES[active];
  const activeState = active && states.find((s) => s.id === active);

  return (
    <div
      data-testid="india-branch-map"
      className="relative max-w-lg mx-auto [--map-active:#16a34a] [--map-active-hover:#15803d] [--map-stroke:#c9c6ba] dark:[--map-active:#22c55e] dark:[--map-active-hover:#4ade80] dark:[--map-stroke:#404040]"
    >
      <svg viewBox={VIEWBOX} className="w-full" role="img" aria-label="Map of India with active service-area states highlighted">
        {states.map((s) => {
          const isActive = !!ACTIVE_STATES[s.id];
          const isHovered = active === s.id;
          return (
            <path
              key={s.id}
              d={s.path}
              data-testid={isActive ? `map-state-active-${s.id}` : undefined}
              // Inactive states are left empty (no fill) -- only active service
              // areas get a solid color, everything else is just an outline.
              fill={isActive ? (isHovered ? "var(--map-active-hover)" : "var(--map-active)") : "none"}
              stroke="var(--map-stroke)"
              strokeWidth="1.2"
              className={isActive ? "cursor-pointer transition-colors duration-150" : undefined}
              onMouseEnter={() => isActive && setActive(s.id)}
              onMouseLeave={() => isActive && setActive(null)}
              onFocus={() => isActive && setActive(s.id)}
              onBlur={() => isActive && setActive(null)}
              tabIndex={isActive ? 0 : undefined}
            >
              {isActive && <title>{s.name}</title>}
            </path>
          );
        })}
      </svg>

      {activeEntry && (
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 max-w-[calc(100vw-2rem)] bg-[#111] dark:bg-white text-white dark:text-[#111] rounded-md px-3.5 py-2.5 text-xs shadow-lg pointer-events-none whitespace-nowrap text-center" data-testid="branch-tooltip">
          <p className="font-medium">{activeState?.name}</p>
          {activeEntry.map((b) => (
            <p key={b.city} className="text-neutral-400 dark:text-neutral-500 mt-0.5">{b.city} — {b.label}</p>
          ))}
        </div>
      )}

      <div className="flex items-center justify-center gap-2 mt-6 text-[11px] text-neutral-500 dark:text-neutral-400">
        <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: "var(--map-active)" }} />
        Active service area
      </div>
    </div>
  );
}
